import React, { useState } from "react";
import api from "../api/api";
export default function InsertRandomTodosPage() {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState("");

  const urgencyLevels = ["Low", "Medium", "High"];
  const randomUsers = ["Alice", "Bob", "Charlie", "Diana", "Eve"];

  const getRandomDate = () => {
    const start = new Date();
    const end = new Date();
    end.setDate(end.getDate() + 365);
    return new Date(
      start.getTime() + Math.random() * (end.getTime() - start.getTime())
    )
      .toISOString()
      .split("T")[0];
  };

  const generateRandomTodo = () => ({
    task_name: `Task ${Math.floor(Math.random() * 10000)}`,
    description: `Description ${Math.random().toString(36).substring(2, 10)}`,
    assign_to: randomUsers[Math.floor(Math.random() * randomUsers.length)],
    urgency: urgencyLevels[Math.floor(Math.random() * urgencyLevels.length)],
    project_id: null,
    status: "Assigned",
    deadline: getRandomDate(),
  });

  const handleInsertRandomTodos = async () => {
    try {
      setCreating(true);
      setError("");
      for (let i = 0; i < 150; i++) {
        const todoData = generateRandomTodo();
        try {
          await api.post("/todos/", todoData);
        } catch (err) {
          console.error(`Failed to create todo ${i + 1}:`, err);
        }
      }
      alert("200 random todos attempted!");
    } catch (err) {
      setError("Failed to create todos.");
      console.error(err);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {error && (
        <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>
      )}
      <button
        onClick={handleInsertRandomTodos}
        disabled={creating}
        style={{ padding: "10px 20px", fontSize: "16px" }}
      >
        {creating ? "Creating..." : "Insert 200 Random Todos"}
      </button>
    </div>
  );
}
